import { RemoteUserType } from '@/services/sip-js.service';

export const USER_TYPE = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  UNKNOWN: 'unknown',
} as Record<string, RemoteUserType>;
